import { DataGetter, Utag, TealiumData } from "../types";
import { afterNextPaint } from "./afterNextPaint";
import { debugLog } from "./debugLog";

export const getViewData = (dataGetters: Array<DataGetter>): TealiumData => {
  const viewData = dataGetters.reduce(
    (data, dataGetter) => ({
      ...data,
      ...dataGetter(),
    }),
    {},
  );
  return viewData;
};

export const trackView = (
  getUtag: () => Promise<Utag>,
  viewData: TealiumData,
): Promise<void> =>
  getUtag()
    .then((utag) => {
      afterNextPaint(() => {
        debugLog(`Sending CUSTOM_EVENT_TRACK_VIEW data to tealium:`, viewData);
        utag.view(viewData);
      });
    })
    .catch((e) => {
      console.warn(
        "@rea-argonaut/analytics trackView was unable to get utag",
        e,
      );
    });
